import { computed, Signal } from '@angular/core';
import { ThemeService } from './theme';
import { ResponsiveService } from './responsive';

export interface V3LayoutFlags {
  isFinnet: Signal<boolean>;
  isFinnetDesktop: Signal<boolean>;
  isZeroDesktop: Signal<boolean>;
  isDesktop: Signal<boolean>;
}

/**
 * Shared by every V3 component that branches on Zero-desktop vs. Finnet-desktop vs. mobile
 * (V3CompanyProfile, V3ScoresOverview, V3FundamentalScoresAnalysis) — finnetApp is mobile-only
 * in practice, so it's excluded from "Finnet desktop" everywhere this is used.
 */
export function v3LayoutFlags(
  themeService: ThemeService,
  responsiveService: ResponsiveService,
): V3LayoutFlags {
  const isFinnet = computed(() => themeService.isFinnet());
  const isFinnetDesktop = computed(
    () => isFinnet() && !themeService.isFinnetApp() && !responsiveService.isMobile(),
  );
  const isZeroDesktop = computed(() => !isFinnet() && !responsiveService.isMobile());
  const isDesktop = computed(() => isZeroDesktop() || isFinnetDesktop());
  return { isFinnet, isFinnetDesktop, isZeroDesktop, isDesktop };
}
